import { render, staticRenderFns } from "./SitoWeb.vue?vue&type=template&id=b42d51f0&"
import script from "./SitoWeb.vue?vue&type=script&lang=js&"
export * from "./SitoWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports